import React, { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Dashboard/Header";
import Sold from "../../Assets/images/sold.svg";
import wholesalers from "../../Assets/images/wholesalers.svg";
import FooterStrict from "../../Pages/Dashboard/FooterStrict";
import { toast } from "react-toastify";

import { getCustomCategories } from "../../API/Category";

const CompetitiveAnalysis = () => {
  const [categoryDetails, setCategoryDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const competitiveItems = [
    {
      id: 1,
      title: "Category Competitive Analysis",
      description:
        "Analyze category performance and ranking in real time with Al-driven insights.",
      icon: Sold,
      image: wholesalers,
      count: 7,
      viewLink: "/custom-analysis-categories",
      createLink: "/create-edit-custom-analysis-category",
      cateBtn:"view All analyses",
      createBtn: "Create Analysis",
    },
  ];

  const getCategoryDetails = useCallback(async () => {
    setLoading(true);
    try {
      const [categoryDetails] = await Promise.all([getCustomCategories()]);

      setCategoryDetails(categoryDetails);
    } catch (error) {
      toast.error("Failed to fetch category details");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getCategoryDetails();
  }, []);

  return (
    <>
      <Header location={`companyProfile`} />
      <section className="ContentBlock pt-40 pb-24 Main_Block Overview">
        <div className="competitve-analysis-section">
          <div className="container-fluid">
            <div className="Common_Block mb-30">
              <div className="Common_Block_Header d-flex align-items-center justify-content-between">
                <h5>Competitive Analysis</h5>
              </div>
              <div className="Common_Block_Body pt-17 pb-17 pr-14 pl-14 Build_Offer_Block">
                <p>
                  Competitive is an ML Al-powered platform that gives brands a
                  real-time view of their category performance and ranking
                  across wholesalers and retailers. It enables intelligent
                  segmentation, competitor benchmarking, and instant execution
                  of targeted digital campaigns to drive growth.
                </p>
                <div className="Card_Body">
                  <div className="card-items">
                    {competitiveItems.map((item) => (
                      <div className="Card Digital_Coupons" key={item.id}>
                        <div
                          className="Card_Header d-flex align-items-center justify-content-between flex-wrap"
                          style={{ background: "#fff" }}
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={item.icon}
                              className="img-fluid"
                              alt="icon"
                              style={{ height: "22px", width: "22px" }}
                            />
                            <h5
                              style={{
                                marginLeft: "8px",
                                fontSize: "15px",
                                fontWeight: "600"
                              }}
                            >
                              {item.title}
                            </h5>
                          </div>
                        </div>

                        <div className="Card_Body competitive-box">
                          <p>{item.description}</p>
                          <ul className="OverviewList">
                            <li className="newOverview">
                              <div className="Icon">
                                <img
                                  src={item.image}
                                  className="img-fluid"
                                  alt="Retailer"
                                />
                              </div>
                              <div className="OverviewList_Info">
                                <span>{categoryDetails?.length ?? 0}</span>
                              </div>
                            </li>
                          </ul>

                          <div
                            className="d-flex align-items-center mt-30"
                            style={{ marginLeft: "-6px" }}
                          >
                            <button
                              type="button"
                              className="ButtonBlue"
                              style={{
                                borderColor: "#3D8ECC",
                                outline: "none",
                                textTransform:'capitalize'
                              }}
                            >
                              <Link to={item.viewLink} className="text-white">
                                {item.cateBtn}
                              </Link>
                            </button>

                            <button
                              type="button"
                              className="ButtonBlue"
                              style={{
                                background: "#fff",
                                borderColor: "#3D8ECC",
                                outline: "none",
                                textTransform:'capitalize'
                              }}
                            >
                              <Link to={item.createLink}>{item.createBtn}</Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterStrict />
    </>
  );
};

export default CompetitiveAnalysis;
